/**
 * Marker pin colors per mainCategory — ported 1:1 from
 * MapTODO/src/components/map-marker/MapMarker.js
 */

export const CATEGORY_COLORS = {
  Food: '#33359f',
  Coffee: '#8B4513',
  Bars: '#FF007F',
  Party: '#007ca5ff',
  Activity: '#FFD300',
  History: '#B22222',
  Nature: '#228B22',
  Date: '#FF1493',
};

export const DEFAULT_CATEGORY_COLOR = '#535356ff';

export function categoryColor(mainCategory) {
  return CATEGORY_COLORS[mainCategory] || DEFAULT_CATEGORY_COLOR;
}
